module.exports = __webpack_public_path__ + "static/media/RentHouse.be1f3e63.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/GuruProfile/RentHouse.svg
// module id = 2606
// module chunks = 0